import { render, staticRenderFns } from "./PlanetDATAInfo.vue?vue&type=template&id=8bb49f3e&scoped=true&"
import script from "./PlanetDATAInfo.vue?vue&type=script&lang=js&"
export * from "./PlanetDATAInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlanetDATAInfo.vue?vue&type=style&index=0&id=8bb49f3e&lang=scss&scoped=true&"
import style1 from "./PlanetDATAInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb49f3e",
  null
  
)

export default component.exports